import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';
export const SPECIAL_COLUMN_TYPES = [
]

const entityColumns = {
  id: {
    model_name: 'SpecialColumn',
    column_type: 'id',
  },
  created_at: {
    model_name: 'SpecialColumn',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'SpecialColumn',
    column_type: 'datetime',
  },
  title: {
    model_name: 'SpecialColumn',
    column_type: 'string',
  },
  type: {
    model_name: 'SpecialColumn',
    column_type: 'type',
    extra: {
      options: [],
    },
  },
  likes_count: {
    model_name: 'SpecialColumn',
    column_type: 'integer',
  },
  views_count: {
    model_name: 'SpecialColumn',
    column_type: 'integer',
  },
  stars_count: {
    model_name: 'SpecialColumn',
    column_type: 'integer',
  },
  shares_count: {
    model_name: 'SpecialColumn',
    column_type: 'integer',
  },
  comments_count: {
    model_name: 'SpecialColumn',
    column_type: 'integer',
  },
  published_at: {
    model_name: 'SpecialColumn',
    column_type: 'datetime',
  },
  author: {
    model_name: 'SpecialColumn',
    column_type: 'string',
  },
  source: {
    model_name: 'SpecialColumn',
    column_type: 'string',
  },
  share_desc: {
    model_name: 'SpecialColumn',
    column_type: 'string',
  },
  is_top: {
    model_name: 'SpecialColumn',
    column_type: 'boolean',
  },
  content_type: {
    model_name: 'SpecialColumn',
    column_type: 'enum',
  },
  note: {
    model_name: 'SpecialColumn',
    column_type: 'string',
  },
  subtitle: {
    model_name: 'SpecialColumn',
    column_type: 'string',
  },
  cover: {
    model_name: 'SpecialColumn',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  commentable_comment_datum: {
    model_name: 'SpecialColumn',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'commentable_comment_datum',
      model_name: 'CommentableCommentDatum',
      foreign_key: 'target_id',
    },
  },
  target_id: {
    model_name: 'SpecialColumn',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'commentable_comment_datum',
      model_name: 'CommentableCommentDatum',
      foreign_key: 'target_id',
    },
  },
  content: {
    model_name: 'SpecialColumn',
    column_type: 'text',
  },
  markdown_content: {
    model_name: 'SpecialColumn',
    column_type: 'text',
  },
  articles: {
    model_name: 'SpecialColumn',
    column_type: 'has_many',
    extra: {
      association_name: 'articles',
      model_name: 'Article',
      foreign_key: 'article_id',
    },
  },
  article_ids: {
    model_name: 'SpecialColumn',
    column_type: 'has_many',
    extra: {
      association_name: 'articles',
      model_name: 'Article',
      foreign_key: 'article_id',
    },
  },
  special_column_article_relations: {
    model_name: 'SpecialColumn',
    column_type: 'has_many',
    extra: {
      association_name: 'special_column_article_relations',
      model_name: 'SpecialColumnArticleRelation',
      foreign_key: 'special_column_id',
    },
  },
  special_column_article_relation_ids: {
    model_name: 'SpecialColumn',
    column_type: 'has_many',
    extra: {
      association_name: 'special_column_article_relations',
      model_name: 'SpecialColumnArticleRelation',
      foreign_key: 'special_column_id',
    },
  },
  recommend_posts: {
    model_name: 'SpecialColumn',
    column_type: 'has_many',
    extra: {
      association_name: 'recommend_posts',
      model_name: 'Post',
      foreign_key: 'post_id',
    },
  },
  recommend_post_ids: {
    model_name: 'SpecialColumn',
    column_type: 'has_many',
    extra: {
      association_name: 'recommend_posts',
      model_name: 'Post',
      foreign_key: 'post_id',
    },
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
